import React, { useCallback } from 'react';
import _keyBy from 'lodash/keyBy';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useAnalytics from 'helpers/useAnalytics';
import { useDispatch, useSelector } from 'react-redux';
import { toggleBubbleOpen, setBubbleSeenByUser, State } from 'store/onboarding';
import useTaskList from 'components/onboarding/useTaskList';

import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import FullscreenIcon from 'components/Icons/Fullscreen';
import FullscreenExitIcon from 'components/Icons/FullscreenExit';
import TaskTitle from 'components/onboarding/TaskTitle';

import { LIST_SLIDE_KEY } from 'components/onboarding/constants';

function BubbleHeading() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const analytics = useAnalytics();
  const taskList = useTaskList();
  const onboardingState: State = useSelector((state: any) => state.onboarding);
  const { bubbleOpen: open, slideKey, bubbleSeenByUser } = onboardingState;
  const taskLookup = _keyBy(taskList, 'id');

  const handleToggleBubbleOpen = () => {
    dispatch(toggleBubbleOpen());
    !bubbleSeenByUser && dispatch(setBubbleSeenByUser());
    if (open) {
      analytics.track('Onboarding Overlay closed', {
        category: 'AD - Onboarding',
      });
    } else {
      analytics.track('Onboarding Overlay opened', {
        category: 'AD - Onboarding',
      });
    }
  };
  const renderHeading = useCallback(() => {
    if (slideKey === LIST_SLIDE_KEY) {
      return <Typography>Onboarding Checklist</Typography>;
    }

    return <TaskTitle task={taskLookup[slideKey]} />;
  }, [slideKey]);

  return (
    <div className={classes.header} data-testid="bubble-heading">
      {!open && renderHeading()}
      <IconButton
        onClick={handleToggleBubbleOpen}
        className={classes.button}
        aria-label="toggle-open-onboarding-overlay"
      >
        {open ? (
          <FullscreenExitIcon data-testid="collapse-icon" />
        ) : (
          <FullscreenIcon data-cy="expand-icon" data-testid="expand-icon" />
        )}
      </IconButton>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
  },
  button: {
    marginLeft: 'auto',
  },
}));

export default BubbleHeading;
